import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { novels, categories } from "@/mocks/novels";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categorySlug = decodeURIComponent(slug || "全部");

  const filteredNovels =
    categorySlug === "全部"
      ? novels
      : novels.filter((n) => n.slug === categorySlug);

  const formatReads = (reads: number) => {
    if (reads >= 10000) return `${(reads / 10000).toFixed(0)}万`;
    return reads.toString();
  };

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb />
        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "BreadcrumbList",
                  itemListElement: [
                    { "@type": "ListItem", position: 1, name: "首页", item: "https://po18-faceheart.com" },
                    { "@type": "ListItem", position: 2, name: categorySlug === "全部" ? "全部小说" : categorySlug, item: `https://po18-faceheart.com/category/${slug}` },
                  ],
                }),
              }}
            />
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {categorySlug === "全部" ? "全部小说" : categorySlug}
            </h1>
            <p className="text-sm text-foreground-500 mb-8">
              共 {filteredNovels.length} 本小说
            </p>

            <div className="flex items-center gap-2 flex-wrap mb-8">
              {categories.map((cat) => {
                const isActive =
                  categorySlug === cat.slug ||
                  (categorySlug === "全部" && cat.slug === "全部");
                return (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                      isActive
                        ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                        : "bg-background-100 text-foreground-600 hover:bg-background-200"
                    }`}
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    {cat.name}
                  </Link>
                );
              })}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-product-shop="">
              {filteredNovels.map((novel) => (
                <Link
                  key={novel.id}
                  to={`/article/${novel.id}`}
                  className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={novel.coverImage}
                      alt={novel.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">
                        {novel.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1 truncate">
                      {novel.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-2">
                      {novel.author}
                    </p>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                      {novel.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="flex items-center gap-0.5 text-xs text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                        {novel.rating}
                      </span>
                      <span className="text-xs text-foreground-400">
                        {formatReads(novel.reads)} 阅读
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}